<template>
    <b-modal id="modal-protesto-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalProtestoDetalhe">
       <template v-slot:modal-header="{ close }">
            <h5 v-if="!(loading || error)">Solicitação de Protesto nº {{ nrPedido }}</h5>
        </template>
        <template v-slot:default="{ hide }">
            <template v-if="loading || error">
                <div v-if="loading" class="text-center"
                    style="
                        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
                        width: 100%;
                        height: 100%;
                        display: block;
                        z-index: 10002;
                        margin: 0;
                    "
                >
                    <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Text Centered"
                    ></b-spinner>
                    <br /><span style="color: #004e86">Processando Aguarde...</span>
                </div>
            </template>
            <template v-else>
              <ModalUploadDocumentos
                  modal-id="upload-modal-protesto-detalhe"
                  title="Upload de Documentos"
                  :accepted-types="'.pdf, .xls, .xlsx, .p7s, .zip'"
                  :max-file-size="5300000"
                  :max-files="1"
                  :allow-multiple="false"
                  @files-selected="handleFilesSelectedProtestoDetalhe"
              />
              <div style="cursor: pointer" @click="openUploadDocumentosModalProtestoDetalhe">
                <b-alert :show="pedidoProtesto.ic_aguardando_anexo" variant="danger" class="text-center">Pedido aguardando anexo de arquivo para prosseguir, <b>clique aqui para anexar</b></b-alert>
              </div>
                <b-row>
                    <b-col class="col-xl-6 col-12 card-column-left">
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>{{deveExibirNomenclaturaCheque ? 'Dados do Cheque' : 'Dados do Título'}}</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nosso Número:</b> {{ pedidoProtesto.nm_nosso_numero }}</span>
                                <span><b>{{deveExibirNomenclaturaCheque ? 'N.º Cheque:' : 'N.º Título:'}}</b> {{ pedidoProtesto.nm_nr_titulo }}</span>
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Valor do Cheque:' : 'Valor Título:'}}</b> {{ pedidoProtesto.vl_titulo }}</span>
                                <span><b>Valor Protestado:</b> {{ pedidoProtesto.vl_saldo }}</span>
                                <span><b>Espécie:</b> {{ pedidoProtesto.ds_especie }}</span>
                                <span v-show="pedidoProtesto.sg_especie == 'CH' && pedidoProtesto.ds_justificativa_cheque"><b>Justificativa:</b> {{ pedidoProtesto.ds_justificativa_cheque }}</span>
                                <template v-show="statusGerarLote.indexOf(pedidoProtesto.cdStatus) < 0">
                                    <span><b>N.º Cartório:</b> {{ pedidoProtesto.nrCartorio }}</span>
                                    <span><b>N.º Protocolo:</b> {{ pedidoProtesto.nm_nr_protocolo }} </span>
                                    <span><b>Data Protocolo:</b> {{ pedidoProtesto.dt_protocolo }} </span>
                                    <span><b>Valor p/ {{ pedidoProtesto.ic_postecipado  ? 'Retirada' : 'Protesto'}}</b> {{ pedidoProtesto.vl_custa }}</span>
                                </template>
                                <!-- <span v-show="pedidoProtesto.nr_cartorio"><b>N.º Cartório:</b> {{ pedidoProtesto.nr_cartorio }}</span> -->
                                <!-- <span v-show="pedidoProtesto.nr_protocolo"><b>N.º Protocolo:</b> {{ pedidoProtesto.nr_protocolo }}</span> -->
                                <!-- <span v-show="pedidoProtesto.dt_protocolo"><b>Data Protocolo:</b> {{ pedidoProtesto.dt_protocolo }}</span> -->
                                <!-- <span v-show="pedidoProtesto.vl_custa"><b>Valor p/ Retirada:</b> {{ pedidoProtesto.vl_custa }}</span> -->
                                <span><b>Data de Solicitação:</b> {{ pedidoProtesto.dt_cadastro }}</span>
                                <span><b>Data Emissão:</b> {{ pedidoProtesto.dt_emissao }}</span>
                                <span><b>Data Vencimento:</b> {{ pedidoProtesto.dt_vencimento }}</span>
                                <span><b>Decl. Portador:</b> {{ pedidoProtesto.sg_declaracao_portador }}</span>
                                <span><b>Falência:</b> {{ pedidoProtesto.ic_protesto_falencia }}</span>
                                <span><b>Art. 9A da Lei 9430:</b> {{ pedidoProtesto.ic_finalidade_pedido }}</span>
                                <span><b>Endosso:</b> {{ pedidoProtesto.sg_tipo_endosso }}</span>
                                <span><b>Aceite:</b> {{ pedidoProtesto.ic_aceite }}</span>
                                <span v-show="pedidoProtesto.ocorrencia"><b>Ocorrência:</b> {{ pedidoProtesto.ocorrencia }}</span>
                                <span v-show="pedidoProtesto.dt_ocorrencia_c"><b>Data da Ocorrência:</b> {{ pedidoProtesto.dt_ocorrencia_c }}</span>
                                <span v-show="pedidoProtesto.ds_motivo_irregularidade_c"><b>Irregularidade:</b> {{ pedidoProtesto.ds_motivo_irregularidade_c }}</span>
                                <span v-show="pedidoProtesto.cd_chave_unica"><b>Chave Única:</b> {{ pedidoProtesto.cd_chave_unica }}</span>
                            </div>
                        </div>
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>Dados do Solicitante</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nome:</b> {{ pedidoProtesto.nm_usuario }}</span>
                                <span><b>Documento:</b> {{ pedidoProtesto.nm_nr_cpfcnpj }}</span>
                                <span><b>Telefone:</b> {{ pedidoProtesto.nm_nr_telefone }}</span>
                                <span><b>Celular:</b> {{ pedidoProtesto.nm_nr_celular }}</span>
                                <span><b>E-mail:</b> {{ pedidoProtesto.nm_email }}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-12 card-column-right">
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>Dados do Cartório</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nome:</b> {{ pedidoProtesto.nome }}</span>
                                <span><b>CNPJ:</b> {{ pedidoProtesto.cnpj }}</span>
                                <span><b>E-mail:</b> {{ pedidoProtesto.email }}</span>
                                <span><b>Telefone:</b> {{ pedidoProtesto.telefone }}</span>
                                <!-- <span v-if="statusGerarLote.indexOf(pedidoProtesto.cdStatus) < 0"><b>Arq. Remessa: </b><a href="#" @click="downloadCnab()"><font-awesome-icon icon="download" /> Remessa</a></span> -->
                                <span v-if="pedidoProtesto.tem_probatorio == 1"><b>Documento Anexo: <a href="#" @click="downloadComprobatorio()" class="text-info"><font-awesome-icon class="text-info" size="1x" icon="file-alt" /> Anexo</a></b></span>
                                <span><b>Pedido de protesto: <a class="text-danger" href="#" @click="downloadPedido()"><font-awesome-icon class="text-danger" size="1x" icon="file-pdf" /> Pedido</a></b></span>
                                <!-- <span><b>Status Pedido:</b> {{ pedidoProtesto.nm_status + (pedidoProtesto.statusPgto ? ' - ' + pedidoProtesto.statusPgto : null)}}</span> CORRIGIR CAMPO STATUSPGTO -->
                                <span><b>Status Pedido:</b> {{ pedidoProtesto.nm_status }}</span>
                                <span v-if="pedidoProtesto.exibeDownloadNotaDev">
                                    <b>Nota Devolutiva: 
                                    <a @click="downloadNotaDev()" class="text-danger" v-if="pedidoProtesto.temNotaDevolutiva == 'true'"><font-awesome-icon class="text-danger" size="1x" icon="file-pdf" /></a></b>
                                    <!-- <input type="file" name="arquivo" class="form-control" ref="notadevolutivafile" accept=".pdf" @change="anexaNotaDevolutiva($event, protesto.pedido)"> -->
                                </span>
                                <span v-show="pedidoProtesto.cdStatus == 5"><b>Motivo Recusa:</b> {{ pedidoProtesto.motivoRecusa }}</span>
                            </div>
                        </div>
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>{{deveExibirNomenclaturaCheque ? 'Endossante' : 'Dados do Sacador'}}</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Endossante:' : 'Sacador:'}}</b> {{ pedidoProtesto.nm_sacador }}</span>
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Doc. Endossante:' : 'Doc. Sacador:'}}</b> {{ pedidoProtesto.nm_nr_documento_sacador }}</span>
                                <span><b>CEP:</b> {{ pedidoProtesto.nm_nr_cep_sacador }}</span>
                                <span><b>Endereco:</b> {{ pedidoProtesto.nm_endereco_sacador + ' - ' + pedidoProtesto.bairro_sacador }}</span>
                                <span><b>Cidade / UF:</b> {{ pedidoProtesto.nm_cidade_sacador + ' - ' + pedidoProtesto.sg_uf_sacador }}</span>
                                <span><b>Celular:</b> {{ pedidoProtesto.nm_nr_celular_sacador }}</span>
                                <span><b>E-mail:</b> {{ pedidoProtesto.nm_email_sacador }}</span>
                            </div>
                        </div>
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>{{deveExibirNomenclaturaCheque ? 'Endossatário' : 'Dados do Cedente'}}</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Endossatário:' : 'Cedente:'}}</b> {{ pedidoProtesto.nm_cedente }}</span>
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Doc. Endossatário:' : 'Doc. Cedente:'}}</b> {{ pedidoProtesto.nm_nr_documento_cedente }}</span>
                                <span><b>CEP:</b> {{ pedidoProtesto.nm_nr_cep_cedente }}</span>
                                <span><b>Endereco:</b> {{ pedidoProtesto.nm_endereco_cedente + ' - ' + pedidoProtesto.nm_bairro_cedente }}</span>
                                <span><b>Cidade / UF:</b> {{ pedidoProtesto.nm_cidade_cedente + ' - ' + pedidoProtesto.sg_uf_cedente }}</span>
                            </div>
                        </div>
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>{{deveExibirNomenclaturaCheque ? 'Emitente' : 'Dados do Devedor'}}</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Emitente:' : 'Devedor:'}}</b> {{ pedidoProtesto.nm_devedor }}</span>
                                <span><b>{{deveExibirNomenclaturaCheque ? 'Doc. Emitente:' : 'Doc. Devedor:'}}</b> {{ pedidoProtesto.nm_nr_identificacao_devedor }}</span>
                                <span><b>CEP:</b> {{ pedidoProtesto.nm_nr_cep_devedor }}</span>
                                <span><b>Endereço:</b> {{ pedidoProtesto.nm_endereco_devedor }}</span>
                                <span><b>Bairro:</b> {{ pedidoProtesto.nm_bairro_devedor }}</span>
                                <span><b>Cidade / UF:</b> {{ pedidoProtesto.nm_cidade_devedor + ' - ' + pedidoProtesto.sg_uf_devedor }}</span>
                                <span><b>Celular:</b> {{ pedidoProtesto.nm_nr_celular_devedor }}</span>
                                <span><b>E-mail:</b> {{ pedidoProtesto.nm_email_devedor }}</span>
                            </div>
                        </div>
                        <div class="modal-card" v-if="hasHistoricoBoleto">
                            <div class="modal-card-header">
                                <h3>Histórico boleto Liquidação</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Pedido:</b> {{ historicoBoleto.codigoPedido }}</span>
                                <span><b>Vlr. Recebimento:</b> {{ historicoBoleto.valorBoleto }}</span>
                                <span><b>Forma Pgto.:</b> {{ historicoBoleto.formaPagamento }}</span>
                                <span></span>
                                <span class="d-none d-xl-block"><b>Status</b></span>
                                <span class="d-none d-xl-block"><b>Data</b></span>
                                <template v-for="(historico, index) in historicoBoleto.historicos">
                                    <span class="d-block d-xl-none"><b>Status</b> {{ (1+index) + ' - ' + historico.nm_boleto_status }}</span>
                                    <span class="d-none d-xl-block">{{ (1+index) + ' - ' + historico.nm_boleto_status }}</span>
                                    <span class="d-block d-xl-none"><b>Data</b> {{ historico.dt_cadastro }}</span>
                                    <span class="d-none d-xl-block">{{ historico.dt_cadastro }}</span>
                                </template>
                            </div>
                        </div>
                        <!-- <div class="modal-card" v-if="hasHistoricoTed">
                            <div class="modal-card-header">
                                <h3>Histórico da TED</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Pagamento:</b> {{ historicoTed.nr_pagamento }}</span>
                                <span><b>Vlr. Pagamento:</b> {{ historicoTed.vl_ted }}</span>
                                <div class="row-body" v-for="(historico, index) in historicoTed.historicos">
                                    <span><b>Status</b><br>{{ historico.statusTed }}</span>
                                    <span><b>Ocorrência</b><br>{{ historico.nm_descricao + ' - ' + historico.ds_erro }}</span>
                                    <span><b>Data</b><br>{{ historico.dt_cadastro}}</span>
                                </div>
                                <b-button v-if="pedidoProtesto.ic_download_comprovante" class="download-ted" variant="info" @click="downloadComprovanteTed(pedidoProtesto.cd_pedido_cartorio_liquidacao)"><font-awesome-icon size="1x" icon="download"/> Comprovante TED</b-button>
                            </div>
                        </div> -->
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-slot:modal-footer="{ ok }">
          <b-button :disabled="loading" v-if="pedidoProtesto.ic_aguardando_anexo" class="upload-anexo mr-3" variant="info" @click="openUploadDocumentosModalProtestoDetalhe"><font-awesome-icon size="1x" class="mr-2" icon="upload"/>Enviar Anexo</b-button>
          <b-button :disabled="loading" size="lg" variant="success" @click="devolveResposta('s')" >Fechar</b-button>
        </template>
    </b-modal>
</template>
<script>

import API from '../../services/api';
import ModalUploadDocumentos from "@/components/documentos/modal_upload_documentos/ModalUploadDocumentos.vue";
export default {
    props:{
        nrPedidoProtesto : ''
    },
    components:{
      ModalUploadDocumentos
    },
    methods: {
        openUploadDocumentosModalProtestoDetalhe(){
          this.$bvModal.show('upload-modal-protesto-detalhe');
        },
        async handleFilesSelectedProtestoDetalhe({ action, files }) {
          if (action !== 'upload' || !files || !files.length) return;

          this.loading = true

          try {
            // Upload de arquivos em paralelo
            const results = await Promise.all(
                files.map(file => this.uploadDocumento(file))
            )
            this.$bvToast.toast(`${results.length} documento(s) enviado(s) com sucesso`, {
              title: 'Arquivo(s) anexado(s)!',
              variant: 'success',
              toaster: 'b-toaster-bottom-center',
              autoHideDelay: 5000,
              solid: true
            })

          } catch (error) {
            this.$bvToast.toast('Erro ao enviar documentos', {
              title: 'Erro ao anexar arquivo(s)!',
              variant: 'danger',
              toaster: 'b-toaster-bottom-center',
              autoHideDelay: 5000,
              solid: true
            })
          } finally {
            this.loading = false
            this.$bvModal.hide('upload-modal-protesto-detalhe')
          }
        },
        uploadDocumento(file) {
          const formData = new FormData()
          const token = localStorage.getItem("jwtToken");
          formData.append('file', file)
          formData.append("token", token);
          formData.append("cd_pedido_protesto", this.nrPedidoProtesto);

          return API.post(`protesto/anexaArquivo`, formData);
        },
        getPedidoProtestoDetalhe(){
            this.loading = true;
            this.error = false;
            let token = localStorage.getItem('jwtToken');
            API.get(`/protesto/protestoDetalhe/${this.nrPedidoProtesto}?token=${token}`).then((res) => {
                this.modalProtestoOk = true;
                this.pedidoProtestoDados = res.data.pedidoProtestoDados;
                this.historicoBoletoDados = res.data.historicoBoletoDados;
                this.historicoTedDados = res.data.historicoTedDados;
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
                this.error = true;
                console.log(error);
            });
        },
        devolveResposta(resposta) {
            this.loading = true;
            this.cleanModal();
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-protesto-detalhe');
        },
        cleanModal(){
            this.nrPedidoProtesto = null;
            this.pedidoProtestoDados ={};
            this.historicoTedDados ={};
            this.historicoBoletoDados =[];
        },
        // #region funções auxiliares para montar a apresentação de valores
        getFormaPagtoLiquidacao(string) {
            switch (string.substr(0, 3)) {
                case 'EPB': return 'Boleto'
                case 'EPP': return 'PIX'
                case 'EPC': return 'Cartão'
                default: return 'Boleto'
            }
        },
        getStatusHistoricoTed(ds_erro, cd_ted_arquivo_status, nm_ted_status) {
            switch (ds_erro) {
                case 'HA':
                    return 'Em processamento';
                case 'BW':
                    return '2 - Processado';
                default:
                    return cd_ted_arquivo_status + ' - ' + nm_ted_status;
            }
        },
        formatDataHora(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora;
        },
        formatData(string){
            return string ? string.split('-').reverse().join('/') : '';
        },
        formatDocumento(string) {
            if (string == null) {
                return '';
            } else {
                let v = string;
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                            .replace(/\.(\d{3})(\d)/, ".$1/$2")
                            .replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
        },
        formatCep(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{3})\d+?$/, '$1');
        },
        formatPhone(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{2})(\d)/, '($1) $2')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{4})\d+?$/, '$1');
        },
        transporEndosso: function (endosso) {
            switch (endosso) {
                case 'M': return 'Mandato'
                case 'T': return 'Translativo'
                case '':
                case ' ': return 'Sem endosso'
            }
        },
        transporAceite: function (aceite) {
            switch (aceite) {
                case 'A': return 'Sim'
                case 'N': return 'Não'
                case '':
                case ' ': return 'Sem aceite'
            }
        },
        transporFalimentares: function (falimentar) {
            switch (falimentar) {
                case 'F': return 'Sim'
                case '':
                case ' ': return 'Não'
            }
        },
        transporDeclaracao: function (declaracao) {
            switch (declaracao) {
                case 'C': return 'Por indicação';
            }
        },
        // #endregion
        // #region downloads -- detalhe do pedido
        // /protesto/comprovanteTed
        // /protesto/pdfPedidoAnexo
        // /protesto/pdfPedidoAnexo - cd_pedido_cartorio_liquidacao
        /**
        *
        baixarPDF: function (linha) {
            if (linha.cd_pedido_protesto) {
                const token = localStorage.getItem("jwtToken");
                let self = this,
                id = linha.cd_pedido_protesto
                this.loading = true;
                API.post("protesto/pdfPedidoAnexo", { token, cd_pedido_protesto: id }).then((res) => {
                    //console.log(res.data.dados)
                    self.loading = false;
                    let dlnk = document.getElementById("dwnldLnk");
                    dlnk.href = "data:application/pdf;base64," + res.data.dados.ds_complemento_registro;
                    dlnk.click();
                    if (res.data.dados.ds_imagem != null) {
                        self.baixarAnexoPdf(id, res.data.dados.ds_imagem);
                    }
                    if (res.data.dados.cd_pedido_cartorio != null) {
                        self.baixarReciboPdf(id, res.data.dados.ds_imagem, res.data.dados.cd_pedido_cartorio);
                    }
                }).catch(() => {
                this.loading = false;
                alert("Falha ao realizar o Download");
                });
            }
        },
        *
        *
        * **/
        // downloadCnab: function () {
        //     this.carregando = true;
        //     axios({
        //         url: '/ajax/pedidos/protesto/arquivo/remessa',
        //         data: { pedido: this.pedidoProtesto.cd_pedido_protesto },
        //         method: 'POST'
        //     }).then(res => {
        //         this.carregando = false;
        //         if (res.status === 200) {
        //             let url = window.URL.createObjectURL(new Blob([res.data])),
        //                 link = document.createElement('a');

        //             link.href = url;
        //             link.setAttribute('download', res.headers.filename);
        //             link.click();
        //         }
        //     }).catch(err => {
        //         this.carregando = false;
        //         // this.gerarMensagem('error', null, 'Não foi possível recuperar o arquivo, entre em contato conosco', null);
        //         console.log(err);
        //     })
        // },
        downloadComprovanteTed: function (cd_pedido_cartorio_liquidacao){
            const token = localStorage.getItem("jwtToken");
            var self = this;
            this.carregando = true;
            API.post(
                "/protesto/comprovanteTed",
                { cd_pedido_cartorio: cd_pedido_cartorio_liquidacao, token: token },
                { responseType: "arraybuffer", }
            ).then(
                function (res) {
                    let blob = new Blob([res.data], {
                        type: "application/pdf",
                    });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "comprovante.pdf";
                    link.click();
                    this.carregando = false;
                },
                function (err) {
                    this.carregando = false;
                    alert("Erro ao gerar recibo");
                    console.log(err);
                }
            );
        },
        downloadComprobatorio: function () {
            if (this.pedidoProtesto.cd_pedido_protesto) {
                this.carregando = true;
                let token = localStorage.getItem("jwtToken");
                let self = this;
                API.post("protesto/pdfPedidoAnexo", { token, cd_pedido_protesto: self.pedidoProtesto.cd_pedido_protesto }).then((res) => {
                    this.carregando = false;

                    let url = 'data:' + res.data.files.anexo.mime + ';base64,' + res.data.dados.ds_imagem;
                    let link = document.createElement('a');
                    let nomeArquivo = res.data.files.anexo.filename;
                    link.href = url;
                    link.setAttribute('download', nomeArquivo);
                    link.click();

                }).catch(err => {
                    this.carregando = false;
                    // this.gerarMensagem('error', null, 'Falha no momento de recuperar o arquivo de PDF', null);
                    console.log(err);
                })

            }
        },
        // downloadIP: function (linha) {
        //     if (linha.nm_chave_ip != null)
        //         window.open("../../home/consulta/titulos/getFile/" + linha.nm_chave_ip, "_blank");
        //     else
        //         // this.gerarMensagem('error', null, 'Instrumento de Protesto não enviado pelo Cartório', null);
        // },
        downloadPedido: function () {
            if (this.pedidoProtesto.cd_pedido_protesto) {
                this.carregando = true;
                let token = localStorage.getItem("jwtToken");
                let self = this;
                API.post("protesto/pdfPedidoAnexo", { token, cd_pedido_protesto: self.pedidoProtesto.cd_pedido_protesto }).then((res) => {
                    this.carregando = false;

                    let url = 'data:' + res.data.files.pedido.mime + ';base64,' + res.data.dados.ds_complemento_registro;
                    let link = document.createElement('a');
                    let nomeArquivo = res.data.files.pedido.filename;
                    link.href = url;
                    link.setAttribute('download', nomeArquivo);
                    link.click();

                }).catch(err => {
                    this.carregando = false;
                    // this.gerarMensagem('error', null, 'Falha no momento de recuperar o arquivo de PDF', null);
                    console.log(err);
                })

            }
        },
        downloadNotaDev: function () {
            if (this.pedidoProtesto.cd_pedido_protesto) {
                this.carregando = true;
                let token = localStorage.getItem('jwtToken');
                API.post('protesto/pedidos/arquivo/notadev?token=' + token, { cd_pedido_protesto: this.pedidoProtesto.cd_pedido_protesto }).then(res => {
                    this.carregando = false;
                    if (res.status === 200) {
                        var byteChar = atob(res.data.pedido),
                            byteNum = new Array(byteChar.length);

                        for (var i = 0; i < byteChar.length; i++) {
                            byteNum[i] = byteChar.charCodeAt(i);
                        }

                        let byteArr = new Uint8Array(byteNum),
                            arquivo = new Blob([byteArr]);

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(arquivo);
                            return;
                        }

                        let url = window.URL.createObjectURL(arquivo),
                            link = document.createElement('a'),
                            nomeArquivo = 'nota_devolutiva_' + this.pedidoProtesto.cd_pedido_protesto + '.pdf';

                        link.href = url;
                        link.setAttribute('download', nomeArquivo);
                        link.click();
                    }
                }).catch(err => {
                    this.carregando = false;
                    // this.gerarMensagem('error', null, 'Falha no momento de recuperar o arquivo de PDF', null);
                    console.log(err);
                })

            }
        },
        isAguardandoAnexo(protesto){
          return protesto.cd_pedido_p_status == 35;  // Pedidos com status 35 - "Aguardando Envio de Documento Anexo"
        },
        //#endregion
    },
    data(){
        return{
            loading:false,
            error:false,
            resposta: 's',
            currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
            pedidoProtestoDados:{},
            historicoTedDados:{},
            historicoBoletoDados:[],
            modalProtestoOk:false,
            statusGerarLote: [1, 13, 15],
            carregando: false,
        }
    },
    computed:{
        deveExibirNomenclaturaCheque(){
            if(!this.pedidoProtesto || !this.pedidoProtesto.sg_especie) return false;

            // Verifica se a espécie é CH
            if(this.pedidoProtesto.sg_especie !== 'CH') return false;

            // Verifica a data de corte (20/11/2025 às 09:00)
            const dataCorte = new Date(2025, 10, 20, 9, 0, 0); // 20/11/2025 às 09:00 (mês é 0-indexado)
            const agora = new Date();

            return agora >= dataCorte;
        },
        hasHistoricoTed(){
            return (this.historicoTedDados && this.historicoTedDados.length > 0?true:false);
        },
        hasHistoricoBoleto(){
            return (this.historicoBoletoDados && this.historicoBoletoDados.length > 0?true:false);
        },
        nrPedido(){
            if(this.nrPedidoProtesto !== undefined && this.nrPedidoProtesto !== null) return this.nrPedidoProtesto.toLocaleString();
            else return '';
        },
        pedidoProtesto(){
            if(this.pedidoProtestoDados !== undefined && this.pedidoProtestoDados !== null && this.pedidoProtestoDados.cd_pedido_protesto){
                let protesto             = this.pedidoProtestoDados;

                let cdStatus             = parseInt(protesto.cd_pedido_p_status, 10);
                let nrCartorio           = !isNaN(parseInt(protesto.nm_nr_cartorio, 10)) ? parseInt(protesto.nm_nr_cartorio, 10) : '-';
                let motivoRecusa         = protesto.cd_pedido_p_status == 5 && protesto.ds_alteracao ? protesto.ds_alteracao.trim() : null;
                let ocorrencia           = protesto.ds_ocorrencia_titulo_c ? protesto.ds_ocorrencia_titulo_c.trim() : protesto.ds_ocorrencia_titulo.trim()
                let exibeDownloadNotaDev = ocorrencia.charAt(0) == '5' || cdStatus == '5' ? true : false
                let exibeDownloadCompTED = (protesto.cd_pedido_cartorio_liquidacao && (protesto.cd_ted_status_liq == '2' || protesto.ds_comprovante_ted_pdf_b64 != null));

                let dadosProtesto   = {
                    cd_pedido_protesto: protesto.cd_pedido_protesto,
                    dt_hr_boleto_liq: this.formatDataHora(protesto.dt_hr_boleto_liq),
                    dt_cadastro: this.formatData(protesto.dt_cadastro),
                    dt_protocolo: this.formatData(protesto.dt_protocolo),
                    dt_emissao: this.formatData(protesto.dt_emissao),
                    dt_ocorrencia: this.formatData(protesto.dt_ocorrencia),
                    dt_ocorrencia_c: this.formatData(protesto.dt_ocorrencia_c ? protesto.dt_ocorrencia_c : protesto.dt_ocorrencia),
                    dt_vencimento: this.formatData(protesto.dt_vencimento),
                    nm_nr_identificacao_devedor: this.formatDocumento(protesto.nm_nr_identificacao_devedor),
                    nm_nr_documento_cedente: this.formatDocumento(protesto.nm_nr_documento_cedente),
                    nm_nr_documento_sacador: this.formatDocumento(protesto.nm_nr_documento_sacador),
                    nm_nr_cpfcnpj: this.formatDocumento(protesto.nm_nr_cpfcnpj),
                    cnpj: this.formatDocumento(protesto.cnpj),
                    vl_titulo: protesto.vl_titulo ? this.currencyFormatter.format(protesto.vl_titulo) : '',
                    vl_saldo: protesto.vl_saldo ? this.currencyFormatter.format(protesto.vl_saldo) : '',
                    vl_custa: protesto.vl_custa ? this.currencyFormatter.format(protesto.vl_custa) : '',
                    nm_nr_cep_sacador: this.formatCep(protesto.nm_nr_cep_sacador),
                    nm_nr_cep_cedente: this.formatCep(protesto.nm_nr_cep_cedente),
                    nm_nr_cep_devedor: this.formatCep(protesto.nm_nr_cep_devedor),
                    nm_nr_telefone: this.formatPhone(protesto.nm_nr_telefone),
                    telefone: this.formatPhone(protesto.telefone),
                    nm_nr_celular: this.formatPhone(protesto.nm_nr_celular),
                    nm_nr_celular_sacador: this.formatPhone(protesto.nm_nr_celular_sacador),
                    nm_nr_celular_devedor: this.formatPhone(protesto.nm_nr_celular_devedor),
                    sg_declaracao_portador: this.transporDeclaracao(protesto.sg_declaracao_portador),
                    ic_protesto_falencia: this.transporFalimentares(protesto.ic_protesto_falencia),
                    sg_tipo_endosso: this.transporEndosso(protesto.sg_tipo_endosso),
                    ic_aceite: this.transporAceite(protesto.ic_aceite),
                    cd_pedido_cartorio: protesto.cd_pedido_cartorio ? protesto.cd_pedido_cartorio : '',
                    cd_pedido_cartorio_liquidacao: protesto.cd_pedido_cartorio_liquidacao ? protesto.cd_pedido_cartorio_liquidacao : '',
                    nm_devedor: protesto.nm_devedor ? protesto.nm_devedor : '',
                    nm_nr_titulo: protesto.nm_nr_titulo ? protesto.nm_nr_titulo : '',
                    nm_nr_protocolo: protesto.nm_nr_protocolo ? protesto.nm_nr_protocolo : '',
                    nm_nosso_numero: protesto.nm_nosso_numero ? protesto.nm_nosso_numero : '',
                    temNotaDevolutiva: protesto.temNotaDevolutiva ? protesto.temNotaDevolutiva : '',
                    nm_nr_cartorio: protesto.nm_nr_cartorio ? protesto.nm_nr_cartorio : '',
                    nrCartorio: nrCartorio ? nrCartorio : '',
                    nm_endereco_devedor: protesto.nm_endereco_devedor ? protesto.nm_endereco_devedor : '',
                    nm_cidade_devedor: protesto.nm_cidade_devedor ? protesto.nm_cidade_devedor : '',
                    sg_uf_devedor: protesto.sg_uf_devedor ? protesto.sg_uf_devedor : '',
                    nm_bairro_devedor: protesto.nm_bairro_devedor ? protesto.nm_bairro_devedor : '',
                    nm_email_devedor: protesto.nm_email_devedor ? protesto.nm_email_devedor : '',
                    cd_ibge: protesto.cd_ibge ? protesto.cd_ibge : '',
                    ds_especie: protesto.ds_especie ? protesto.ds_especie : '',
                    nm_cedente: protesto.nm_cedente ? protesto.nm_cedente : '',
                    nm_endereco_cedente: protesto.nm_endereco_cedente ? protesto.nm_endereco_cedente : '',
                    nm_cidade_cedente: protesto.nm_cidade_cedente ? protesto.nm_cidade_cedente : '',
                    sg_uf_cedente: protesto.sg_uf_cedente ? protesto.sg_uf_cedente : '',
                    nm_bairro_cedente: protesto.nm_bairro_cedente ? protesto.nm_bairro_cedente : '',
                    nm_sacador: protesto.nm_sacador ? protesto.nm_sacador : '',
                    nm_email_sacador: protesto.nm_email_sacador ? protesto.nm_email_sacador : '',
                    nm_endereco_sacador: protesto.nm_endereco_sacador ? protesto.nm_endereco_sacador : '',
                    cd_ibge_praca_protesto: protesto.cd_ibge_praca_protesto ? protesto.cd_ibge_praca_protesto : '',
                    sg_uf_praca_protesto: protesto.sg_uf_praca_protesto ? protesto.sg_uf_praca_protesto : '',
                    nm_cidade_sacador: protesto.nm_cidade_sacador ? protesto.nm_cidade_sacador : '',
                    sg_uf_sacador: protesto.sg_uf_sacador ? protesto.sg_uf_sacador : '',
                    cdStatus: cdStatus ? cdStatus : '',
                    cd_pedido_p_status: protesto.cd_pedido_p_status ? protesto.cd_pedido_p_status : '',
                    cd_cartorio: protesto.cd_cartorio ? protesto.cd_cartorio : '',
                    cd_usuario_cadastro: protesto.cd_usuario_cadastro ? protesto.cd_usuario_cadastro : '',
                    tem_probatorio: protesto.tem_probatorio ? protesto.tem_probatorio : false,
                    ic_postecipado: protesto.ic_postecipado ? protesto.ic_postecipado : false,
                    cd_pedido_protesto_origem: protesto.cd_pedido_protesto_origem ? protesto.cd_pedido_protesto_origem : '',
                    distribuicao_estadual_ligada: protesto.distribuicao_estadual_ligada ? protesto.distribuicao_estadual_ligada : '',
                    historico_ted: protesto.historico_ted ? protesto.historico_ted : '',
                    historico_ted_liquidacao: protesto.historico_ted_liquidacao ? protesto.historico_ted_liquidacao : '',
                    pedido_comprovante_liq: protesto.pedido_comprovante_liq ? protesto.pedido_comprovante_liq : '',
                    cd_ted_arquivo_liq: protesto.cd_ted_arquivo_liq ? protesto.cd_ted_arquivo_liq : '',
                    cd_usuario: protesto.cd_usuario ? protesto.cd_usuario : '',
                    nm_usuario: protesto.nm_usuario ? protesto.nm_usuario : '',
                    nm_email: protesto.nm_email ? protesto.nm_email : '',
                    nm_status: protesto.nm_status ? protesto.nm_status : '',
                    totalCodevedores: protesto.totalCodevedores ? protesto.totalCodevedores : '',
                    nome: protesto.nome ? protesto.nome : '',
                    email: protesto.email ? protesto.email : '',
                    nr_cartorio_cra: protesto.nr_cartorio_cra ? protesto.nr_cartorio_cra : '',
                    cidade: protesto.cidade ? protesto.cidade : '',
                    uf: protesto.uf ? protesto.uf : '',
                    codigo_abrancia: protesto.codigo_abrancia ? protesto.codigo_abrancia : '',
                    tipoCartorio: protesto.tipoCartorio ? protesto.tipoCartorio : '',
                    ds_alteracao: protesto.ds_alteracao ? protesto.ds_alteracao : '',
                    motivoRecusa: motivoRecusa,
                    ds_comprovante_ted_pdf_b64: protesto.ds_comprovante_ted_pdf_b64 ? protesto.ds_comprovante_ted_pdf_b64 : '',
                    cd_ted_arquivo: protesto.cd_ted_arquivo ? protesto.cd_ted_arquivo : '',
                    cd_ted_status_liq: protesto.cd_ted_status_liq ? protesto.cd_ted_status_liq : '',
                    cd_chave_unica: protesto.cd_chave_unica ? protesto.cd_chave_unica : '',
                    ic_finalidade_pedido: Boolean(Number(protesto.ic_finalidade_pedido)) ? 'Sim' : 'Não',
                    ds_justificativa_cheque: protesto.ds_justificativa_cheque ? protesto.ds_justificativa_cheque : '',
                    sg_especie: protesto.sg_especie ? protesto.sg_especie : '',
                    cd_boleto: protesto.cd_boleto ? protesto.cd_boleto : '',
                    usuario_boleto_liq: protesto.usuario_boleto_liq ? protesto.usuario_boleto_liq : '',
                    endereco_boleto: protesto.endereco_boleto ? protesto.endereco_boleto : '',
                    nome_solicitante: protesto.nome_solicitante ? protesto.nome_solicitante : '',
                    documento_solicitante: protesto.documento_solicitante ? protesto.documento_solicitante : '',
                    lei9430: protesto.lei9430 ? protesto.lei9430 : '',
                    decl_portador: protesto.decl_portador ? protesto.decl_portador : '',
                    falencia: protesto.falencia ? protesto.falencia : '',
                    endosso: protesto.endosso ? protesto.endosso : '',
                    aceite: protesto.aceite ? protesto.aceite : '',
                    nr_protocolo: protesto.nr_protocolo ? protesto.nr_protocolo : '',
                    nr_cartorio: protesto.nr_cartorio ? protesto.nr_cartorio : '',
                    status_pedido: protesto.status_pedido ? protesto.status_pedido : '',
                    bairro_sacador: protesto.bairro_sacador ? protesto.bairro_sacador : '',
                    ds_ocorrencia_titulo: protesto.ds_ocorrencia_titulo ? protesto.ds_ocorrencia_titulo : '',
                    ds_motivo_irregularidade: protesto.ds_motivo_irregularidade ? protesto.ds_motivo_irregularidade : '',
                    ds_ocorrencia_titulo_c: protesto.ds_ocorrencia_titulo_c ? protesto.ds_ocorrencia_titulo_c : '',
                    ds_motivo_irregularidade_c: protesto.ds_motivo_irregularidade_c ? protesto.ds_motivo_irregularidade_c.trim() :  protesto.ds_motivo_irregularidade,
                    nm_chave_ip: protesto.nm_chave_ip ? protesto.nm_chave_ip : '',
                    dados_bancarios: protesto.dados_bancarios ? protesto.dados_bancarios : '',
                    dados_bancarios_usuario: protesto.dados_bancarios_usuario ? protesto.dados_bancarios_usuario : '',
                    exibeDownloadNotaDev: exibeDownloadNotaDev,
                    ocorrencia: ocorrencia,
                    ic_download_comprovante: exibeDownloadCompTED,
                    ic_aguardando_anexo: this.isAguardandoAnexo(protesto)
                };
                return dadosProtesto;
            }
            else return {}
        },
        historicoBoleto(){
            if(this.historicoBoletoDados && this.historicoBoletoDados.length > 0){
                let boletos = this.historicoBoletoDados;
                let historicoBoleto = {
                    codigoPedido: boletos[0].cd_pedido,
                    valorBoleto: this.currencyFormatter.format(boletos[0].vl_boleto?boletos[0].vl_boleto:''),
                    formaPagamento: this.getFormaPagtoLiquidacao(boletos[0].cd_pedido?boletos[0].cd_pedido:''),
                    historicos:[],
                };
                boletos.forEach(boleto => {
                    historicoBoleto.historicos.push({
                        cd_boleto_status: boleto.cd_boleto_status,
                        vl_boleto: this.currencyFormatter.format(boleto.vl_boleto),
                        cd_pedido: boleto.cd_pedido,
                        nm_boleto_status: boleto.nm_boleto_status,
                        cd_boleto: boleto.cd_boleto,
                        cd_api_boleto_config: boleto.cd_api_boleto_config,
                        dt_cadastro: this.formatDataHora(boleto.dt_cadastro),
                    });
                });                
                return historicoBoleto;
            }            
            return [];
        },
        historicoTed(){
            if(this.historicoTedDados && this.historicoTedDados.length > 0){
                let tedLista = this.historicoTedDados;
                let historicoTed = {
                    vl_ted: this.currencyFormatter.format(tedLista[0].vl_ted?tedLista[0].vl_ted:''),
                    nr_pagamento: tedLista[0].nr_pagamento,
                    historicos:[],
                };
                tedLista.forEach(ted => {
                    historicoTed.historicos.push({
                        cd_ted_arquivo_status: ted.cd_ted_arquivo_status,
                        dt_cadastro: this.formatDataHora(ted.dt_cadastro),
                        nm_descricao: ted.nm_descricao,
                        ds_erro: ted.ds_erro,
                        nm_ted_status: ted.nm_ted_status,
                        statusTed: this.getStatusHistoricoTed(ted.ds_erro, ted.cd_ted_arquivo_status, ted.nm_ted_status)
                    });
                });     
                return historicoTed;
            }
            return {};
        },
    },
    mounted(){
        // this.getPedidoProtestoDetalhe();
    },
    watch:{
        nrPedidoProtesto(val){
            if(val !== undefined && val !== '' && val !== null)
                this.modalProtestoOk = true;
            else
                this.modalProtestoOk = false;
        },
        modalProtestoOk(val){
            if(val){
                this.getPedidoProtestoDetalhe();
            }
        }
    }
}
</script>
<style scoped>

.modal-card{
    display: flex;
    flex-flow: column;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin-bottom: 30px;
    padding: 0 10px;
}
.modal-card-header{
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: .75rem 1.25rem;
}

h5 {
    font: normal normal 200 25px/25px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    margin: 0px;
}
h3 {
    font: normal normal 200 20px/18px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    color:var(--secondary-color) !important;
    margin: 0px;
}
span{
    margin-bottom: 18px;
    font: normal normal 200 16px/17px 'Kanit', sans-serif;
    letter-spacing: -1%;
}
.modal-card-body{
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-left{max-width: 370px;}
.card-column-left .modal-card-body{gap: 0;}
.card-column-right{max-width: calc(100% - 370px)}
.card-column-left .modal-card-body span{
    flex: 1 1 100%;
    max-width: 100%;
}
.card-column-right .modal-card-body .row-body{
    flex: 1 1 95%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-right .modal-card-body .row-body span{
    flex: 1 1 32%;
    max-width: 32%;
}
.card-column-right .modal-card-body > span{
    flex: 1 1 49%;
    max-width: 49%;
}
.btn.btn-success{
    width: 160px;
    height: 44px;
    background: #1ACEB5 0% 0% no-repeat padding-box;
    font: normal normal 500 16px/20px 'Kanit', sans-serif;
    border-radius: 5px;
    opacity: 1;
    border: none;
    outline: none;
}
.btn.btn-success:disabled{
    background:#1aceb55c 0% 0% no-repeat padding-box
}
.btn.btn-success:active,
.btn.btn-success:focus{
    background: #1ACEB5 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: none;
    outline: none;
}
.btn.download-ted {
    min-width: 195px;
    margin-left: auto;
}
.btn.download-ted > * {    
    color: white !important;
}

.btn.btn-info{
  width: 160px;
  height: 44px;
  font: normal normal 500 16px/20px 'Kanit', sans-serif;
  border-radius: 5px;
  opacity: 1;
  border: none;
  outline: none;
}
.btn.btn-info:disabled{
  background-color: #17a2b888;
  border-color: #17a2b888;
}

@media (max-width:1199px) {
    
    .card-column-left{max-width: unset;}
    .card-column-right{max-width: unset;}
    .card-column-right .modal-card-body > span{flex: 1 1 100%;max-width: 100%;}
    .card-column-right .modal-card-body .row-body span{flex: 1 1 100%;max-width: 100%;}
    .btn.download-ted{width: 100%;}
}

</style>